module.exports = __webpack_public_path__ + "createstatic/media/cancel-btn.4ef1808c.svg";